module.exports = __webpack_public_path__ + "img/camp-pass--1x.ca37096f.jpg";